import React, { useState, useEffect, useContext } from 'react'
import { Popover } from '@material-ui/core'
import { Apartment, Room, InfoOutlined, Add, ClearOutlined, Search } from '@material-ui/icons'

import { fetchPropertySuggestion } from '../../PropertySearch/Services/propertySearchService'
import { removeSpecialCharacters, removeWhiteSpace, getTargetMarketPayload, getErrorAlertDuration } from '../../PropertySearch/Utility/Utility.js'
import updatePropertyList from '../Utility/UpdatePropertyList/UpdatePropertyList'
import listContext from '../../Common/context/context'
import Chip from '../../Common/Chip'
import myContext from '../../PropertySearch/FiltersComponent/context/context'
import searchContext from '../../PropertySearch/FiltersComponent/context/context'
import { pollMessageStatus } from '../Utility/GetMessageStatus/GetMessageStatus'

const AddPropertyToList = () => {

    const { propertyList, fetchListDetails } = useContext(listContext)
    const { savedSearch } = useContext(myContext)
    const [anchorEl, setAnchorEl] = React.useState(null)
    const [inputVal, setInputVal] = useState('')
    const [propertySuggestions, setPropertySuggestions] = useState([])
    const [propertiesSelected, setPropertiesSelected] = useState([])
    const [selectedPropertyObjs, setSelectedPropertyObjs] = useState({})
    const [showSuggestions, isShowSuggestions] = useState(false)
    const [showSuggestionSpinner, setShowSuggestionSpinner] = useState(false)
    const [isSearchTargetMarket, setIsSearchTargetMarket] = useState(false)
    const [targetMarket, setTargetMarket] = useState()
    const { fetchSavedLists, setalertProps, setShowAlert, openModalWindow } = useContext(searchContext)
    const [buttonClicked, setButtonClicked] = useState('')
    const [subjectStates, setSubjectStates] = useState([])

    useEffect(() => {
        setTargetMarket(getTargetMarketPayload(savedSearch))
    }, [savedSearch])

    useEffect(
        () => {
            let newSubjectStates = []
            if (propertyList && propertyList.compsList) {
                propertyList.compsList.forEach(item => {
                    if (item.isSubjectProperty) {
                        let state = item.data.omniviewproperty[0].state
                        let stateIndex = newSubjectStates.findIndex(x => x.state === state)
                        if (state && stateIndex == -1) {
                            newSubjectStates.push({
                                state: item.data.omniviewproperty[0].state,
                                isChecked: false
                            })
                        }
                    }
                })
            }
            setSubjectStates(newSubjectStates)
        },
        [propertyList]
    )

    const handleClose = () => {
        if (buttonClicked === '') {
            setAnchorEl(null)
            setInputVal('')
            setPropertySuggestions([])
            setPropertiesSelected([])
            setButtonClicked('')
        }
    }
    const open = Boolean(anchorEl)
    const handleClick = event => {
        setAnchorEl(event.currentTarget)
    }
    const handleChange = e => {
        let { value } = e.target
        setInputVal(value)
    }

    const handleSelection = (id, name) => {

        let temp = [...propertiesSelected]
        let tempObj = { ...selectedPropertyObjs }
        let propertyInfoCacheObj = localStorage.getItem('propertyInfo') ? JSON.parse(localStorage.getItem('propertyInfo')) : {}
        if (propertiesSelected.includes(id)) {
            delete temp[id]
            temp = propertiesSelected.filter(propertyId => propertyId !== id)
        } else {
            tempObj[id] = name
            propertyInfoCacheObj[id.substring(0, id.length - 3)] = name;
            temp.push(id)
        }

        setSelectedPropertyObjs(tempObj)
        setPropertiesSelected(temp)
        localStorage.setItem('propertyInfo', JSON.stringify(propertyInfoCacheObj));
    }
    useEffect(() => {
        if (inputVal.length == 0) {
            setPropertySuggestions([])
        }
        if (inputVal.length >= 3) {
            inputChanged()
        }
    }, [inputVal])

    function inputChanged() {
        let suggestionCriteria = {}
        let newInputValue = inputVal
        newInputValue = removeSpecialCharacters(newInputValue)
        newInputValue = removeWhiteSpace(newInputValue)
        if (newInputValue.length >= 2) {
            setShowSuggestionSpinner(true)
            suggestionCriteria = {
                propertyName: newInputValue,
                separateAddress: true
            }
            if (isSearchTargetMarket && targetMarket) {
                suggestionCriteria.targetMarket = targetMarket
            }

            subjectStates.forEach(element => {
                if (element.isChecked) {

                    if (!suggestionCriteria.hasOwnProperty('targetMarket')) {
                        suggestionCriteria.targetMarket = { prospecting: [] }
                    }

                    if (!suggestionCriteria.targetMarket.hasOwnProperty('prospecting')) {
                        suggestionCriteria.targetMarket.prospecting = []
                    }

                    suggestionCriteria["targetMarket"]["prospecting"].push({
                        state: element.state
                    })
                }
            })

            fetchSuggestion(JSON.stringify({ suggestion: suggestionCriteria }))
        }
    }

    async function fetchSuggestion(payLoad) {
        const response = await fetchPropertySuggestion(payLoad)
        if (response && response.status === 200) {
            if (response.data && response.data.data) {
                if (response.data.data) {
                    let tempSugesstions = response.data.data
                    let existingPropertyId = propertyList.compsList.map(obj => obj.omniViewPropertyId)
                    tempSugesstions = tempSugesstions.filter(property => !(existingPropertyId.includes(property.omniViewPropertyId)))
                    setPropertySuggestions(tempSugesstions)
                    setShowSuggestionSpinner(false)
                    isShowSuggestions(true)
                }
            }
        }
    }

    function getAddress(property) {
        let address = ''
        address = `${property.addressLine1 ? property.addressLine1 : ''}, ${property.city ? property.city : ''}, ${property.state ? property.state : ''} ${property.zipCode ? property.zipCode : ''}`
        address = address.replace(',,', ',')
        address = address.replace(', ,', ',')

        // address = highlightText(address)

        return address
    }

    function getName(property) {
        let name = ''
        try {
            name = `${property.propertyName}`
            name = highlightText(name)
        } catch (e) {
            console.log(e)
        }

        return name
    }

    function highlightText(inputString) {
        let textToHighlight = inputVal.toLowerCase()
        textToHighlight = removeWhiteSpace(textToHighlight)

        inputString = inputString.toLowerCase()
        let splitInput = inputString.split(textToHighlight)

        return (
            <>
                <span className="capitalize">
                    {splitInput.map((value, index) => (
                        <React.Fragment key={index}>
                            {index + 1 >= splitInput.length ?
                                value
                                : <span>{value}<b>{textToHighlight}</b></span>}
                        </React.Fragment>
                    ))
                    }
                </span>
            </>
        )
    }

    const addCompsPropertyToUpdateReq = (compsRankStartsFrom) => {
        let updatedCompsList = []
        let rank = compsRankStartsFrom ? compsRankStartsFrom : 1

        propertyList.compsList.forEach(item => {
            if (!item.isSubjectProperty) {
                updatedCompsList.push({
                    "omniViewCompsListId": item.omniViewCompsListId,
                    "omniViewPropertyId": item.omniViewPropertyId,
                    "isSubjectProperty": item.isSubjectProperty,
                    "rank": rank,
                    "action": "modify"
                })
                rank++
            }
        })
        return updatedCompsList
    }

    const onUpdate = async (message, type) => {

        try {

            if (type === 'success') {
                setPropertySuggestions([])
                setPropertiesSelected([])
                fetchSavedLists()
                await fetchListDetails()
            }
            setalertProps({ message, type, duration: type === 'error' ? getErrorAlertDuration() : '' })
            setShowAlert(true)

            openModalWindow(false)

        } catch (error) {
            console.log(' error in on-Update :: ', error)
        }

    }

    const handleAddProperty = async (type) => {
        setButtonClicked(type)
        let fieldsToUpdate = []
        let omniViewPropertyListId = propertyList.omniViewPropertyListId
        let polarisPropertySearchCriteriaId = propertyList.polarisPropertySearchCriteriaId
        let updatedCompsList = []
        let isSubjectProperty = type === 'comp' ? false : true

        let maxRank = propertyList.compsList && propertyList.compsList.length > 0 ? Math.max(...propertyList.compsList.map(o => o.rank)) : 0;
        maxRank = maxRank ? maxRank + 1 : 1
        let currentRank = isSubjectProperty ? propertyList.compsList.filter(x => x.isSubjectProperty).length + 1 : maxRank

        // if we are adding subject, than rank of all compes will be updated
        if (isSubjectProperty) {
            updatedCompsList = addCompsPropertyToUpdateReq(propertyList.compsList.filter(x => x.isSubjectProperty).length + propertiesSelected.length + 1)
        }

        propertiesSelected.forEach(propertyid => {
            updatedCompsList.push({
                "omniViewPropertyId": propertyid,
                "isSubjectProperty": isSubjectProperty,
                "rank": currentRank,
                "action": "add"
            })
            currentRank++
        })

        fieldsToUpdate.push({ key: 'omniViewPropertyListId', value: omniViewPropertyListId })
        fieldsToUpdate.push({ key: 'polarisPropertySearchCriteriaId', value: polarisPropertySearchCriteriaId })
        fieldsToUpdate.push({ key: 'compsList', value: updatedCompsList })
        fieldsToUpdate.push({ key: 'compType', value: propertyList.compType })

        setInputVal('')
        openModalWindow(true)
        setAnchorEl(null)

        const updatePropertyListObj = new updatePropertyList(fieldsToUpdate)
        const response = await updatePropertyListObj.update()

        setButtonClicked('')

        if (response && response.status === 200) {
            pollMessageStatus(response.data.messageId, onUpdate, '', 'List updated !!', 'Something went wrong !!')
        } else {
            const errorMessage = response.data && response.data.message ? response.data.message : 'Something went wrong !!'
            setalertProps({ message: errorMessage, type: 'error' })
            setShowAlert(true)
        }
    }

    const onChipDelete = (id) => {
        let temp = { ...selectedPropertyObjs }
        delete temp[id]
        setSelectedPropertyObjs(temp)
        setPropertiesSelected(propertiesSelected.filter(e => e !== id))
    }

    const isdisabled = () => {
        let returnVal = false

        const index = savedSearch.findIndex(x => x.isTargetMarket)

        returnVal = index === -1 ? true : false

        return returnVal
    }

    const getSuggestionByCategory = byAdd => {
        if (byAdd) {
            return propertySuggestions.filter(x => x.isAddressResult)
        } else {
            return propertySuggestions.filter(x => !x.isAddressResult)
        }
    }

    const handleSelectState = item => {
        try {
            let stateIndex = subjectStates.findIndex(x => x.state === item.state)
            let newSubjectStates = [...subjectStates]
            newSubjectStates[stateIndex].isChecked = !newSubjectStates[stateIndex].isChecked
            setSubjectStates(newSubjectStates)
        } catch (error) {
            console.log(' error in handleSelectState :: ', error)
        }
    }

    return (
        <>
            <button data-testid="test-add-property" className="btn btn-sm border-1 border-base bg-gray-15 text-primary rounded" onClick={handleClick}>
                + Add Property
            </button>
            <Popover open={open} anchorEl={anchorEl} onClose={handleClose}
                PaperProps={{
                    style: { width: '700px', height: '450px' },
                }}
                anchorOrigin={{ vertical: 'bottom', horizontal: 'left' }}
                transformOrigin={{ vertical: 'top', horizontal: 'left' }} >
                <div className="" >
                    <div className="flex flex-col">
                        <div>
                            <div className="flex justify-between px-6 py-4 border-b-1 border-base">
                                <div data-testid="test-add-property-label" className="pr-6 pt-1 font-semibold">
                                    <Add /> Add property
                                </div>
                                <div>
                                    <a data-testid="test-add-property-close" onClick={handleClose}> <ClearOutlined /> </a>
                                </div>
                            </div>
                        </div>
                        <div className="pt-4 space-x-4 px-6 w-full disable-scrollbars flex flex-row items-center">
                            <div className="bg-gray-5 p-3 flex rounded-pill h-8">
                                {showSuggestionSpinner ? <span className="loader h-6 w-6 items-center justify-center text-center absolute" ></span> : <Search className="absolute" />}
                                <input data-testid="test-input-Search-properties" value={inputVal}
                                    style={{ width: 400 }} onFocus={() => isShowSuggestions(true)}
                                    onChange={handleChange} className="shadow appearance-none pl-7 pr-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline rounded bg-gray-5"
                                    type="text" placeholder="Search for property" />
                            </div>
                            <div>
                                <input data-testid="chk-Search-target-market" disabled={isdisabled()} onChange={() => setIsSearchTargetMarket(!isSearchTargetMarket)} checked={isSearchTargetMarket} type="checkbox" id="chk-Search-target-market" name="chk-Search-target-market" value="false" />
                                <label data-testid="lbl-Search-target-market" htmlFor="chk-Search-target-market" className="px-4">Target Market</label>
                                {/* {isdisabled() ?
                                    <div className="pb-2 text-danger">
                                        <small>Save a search as target market first</small>
                                    </div>
                                    : null} */}
                            </div>
                        </div>
                        <div className="px-10 overflow-y-auto popover-w disable-scrollbars">
                            {showSuggestions &&
                                <div onMouseLeave={() => isShowSuggestions(false)} className={`absolute bg-white shadow-5 overflow-y-auto ${propertySuggestions.length > 0 ? 'h-screen-40 z-auto w-1/2' : ''}`}>
                                    <div className="flex flex-col">
                                        <div className={`sticky-top flex justify-between border-b-1 border-base px-4 py-3 bg-gray-15 text-primary ${propertySuggestions.length ? '' : 'hidden'}`}>
                                            <span >
                                                Suggestions by Name
                                            </span>
                                            <span > <Apartment /> </span>
                                        </div>
                                        <div>
                                            {propertySuggestions.length > 0 ? getSuggestionByCategory(false).map((property, index) => (
                                                <div data-testid={`test-property-option-${index}`}
                                                    onClick={() => handleSelection(property.omniViewPropertyId, property.propertyName)} role="menuitem" key={property.omniViewPropertyId}
                                                    className="flex flex-row border-b-1 border-base px-4 py-3 cursor-pointer hover:bg-gray-15">
                                                    <div className={propertiesSelected.includes(property.omniViewPropertyId) ? 'ml-2 pr-2 absolute' : 'hide ml-2 pr-2 absolute'}>&#10004;</div>
                                                    <div className="pl-6">
                                                        <div className="text-2">{getName(property)}</div>
                                                        <div className="text-muted text-1">
                                                            {getAddress(property)}
                                                        </div>
                                                    </div>
                                                </div>))
                                                : ""}
                                        </div>
                                        <div className={`sticky-top flex justify-between border-b-1 border-base px-4 py-3 bg-gray-15 text-primary ${propertySuggestions.length ? '' : 'hidden'}`}>
                                            <span>
                                                Suggestions by Address
                                            </span>
                                            <span > <Room /> </span>
                                        </div>
                                        <div>
                                            {propertySuggestions.length > 0 ? getSuggestionByCategory(true).map((property, index) => (
                                                <div data-testid={`test-property-option-${index}`}
                                                    onClick={() => handleSelection(property.omniViewPropertyId, property.propertyName)} role="menuitem" key={property.omniViewPropertyId}
                                                    className="flex flex-row border-b-1 border-base px-4 py-3 cursor-pointer hover:bg-gray-15">
                                                    <div className={propertiesSelected.includes(property.omniViewPropertyId) ? 'ml-2 pr-2 absolute' : 'hide ml-2 pr-2 absolute'}>&#10004;</div>
                                                    <div className="pl-6">
                                                        <div className="text-2">{getName(property)}</div>
                                                        <div className="text-muted text-1">
                                                            {getAddress(property)}
                                                        </div>
                                                    </div>
                                                </div>))
                                                : ""}
                                        </div>
                                    </div>
                                </div>
                                // <div onMouseLeave={() => isShowSuggestions(false)} className={`absolute bg-white shadow-5 overflow-y-auto ${propertySuggestions.length > 0 ? 'h-screen-25 w-1/2' : ''}`}>
                                //     {propertySuggestions.length > 0 ? propertySuggestions.map((property, index) => (
                                //         <div data-testid={`test-property-option-${index}`}
                                //             onClick={() => handleSelection(property.omniViewPropertyId, getName(property))} role="menuitem" key={property.omniViewPropertyId}
                                //             className="flex flex-row border-b-1 border-base px-4 py-3 cursor-pointer hover:bg-gray-15">
                                //             <div className={propertiesSelected.includes(property.omniViewPropertyId) ? 'ml-2 pr-2 absolute' : 'hide ml-2 pr-2 absolute'}>&#10004;</div>
                                //             <div className="pl-6">
                                //                 <div className="text-2">{getName(property)}</div>
                                //                 <div className="text-muted text-1">
                                //                     {getAddress(property)}
                                //                 </div>
                                //             </div>
                                //         </div>))
                                //         :
                                //         ""
                                //     }
                                // </div>
                            }
                        </div>
                    </div>
                    <div className="py-4 px-7 flex flex-col">
                        <div className='flex flex-row items-center text-2 items-center'>
                            <label className="items-center" title="Select State to get suggestion from selected state">
                                Filter By State<InfoOutlined style={{ fontSize: "small", "paddingBottom": "2px" }} />
                            </label >
                            {subjectStates.map(value => {
                                return (
                                    <>
                                        <span data-testid={`test-select-subject-state-${value.state}`}
                                            onClick={() => handleSelectState(value)}
                                            className={`capitalize cursor-pointer badge rounded-pill px-5 ml-3 py-2 border-1 border-base ${value.isChecked ? 'text-primary bg-gray-10' : 'bg-white'}`}>
                                            {value.state}
                                        </span>
                                    </>
                                )
                            })}
                        </div>
                        <div>
                            <InfoOutlined style={{ fontSize: "small", "paddingBottom": "2px" }} />
                            <label class="text-1">Select State to get suggestion from selected state</label>
                        </div>
                    </div>
                    <div className="py-4 px-7">
                        <div className=" flex flex-wrap">
                            {propertiesSelected.map((t, i) =>
                                <Chip key={t} onChipDelete={onChipDelete}
                                    name={<a href={`${window.REACT_GLOBAL_CONFIG.SF_URL}${t}`}
                                        target="_blank"
                                        rel="noopener noreferrer">{selectedPropertyObjs[t]}
                                    </a>}
                                    id={t} />
                                // <Chip key={t} onChipDelete={onChipDelete} name={selectedPropertyObjs[t]} id={t} />
                            )}
                        </div>
                    </div>
                    <div className="absolute bottom-0 w-full">
                        <div className="border-t-1 border-base flex justify-end px-6 py-4 space-x-4 items-center">
                            <div>
                                <button data-testid='test-button-cancel' onClick={handleClose} className='btn btn-sm' type='button'>
                                    Close
                                </button>
                            </div>
                            <div>
                                {buttonClicked == 'subj' ?
                                    <button data-testid='test-button-subjects' className="btn btn-sm bg-gray-10 c-disabled">
                                        <span className="loader h-5 w-5 mx-2" ></span>
                                        <span className="px-2">+ Add subject</span>
                                    </button>
                                    :
                                    <button data-testid='test-add-subjects'
                                        onClick={() => { handleAddProperty('subj') }}
                                        className={`btn btn-sm bg-gray-10 rouded ${propertiesSelected.length === 0 ? 'c-disabled' : ''}`}>
                                        + Add subject
                                    </button>
                                }
                                {/* <button data-testid="test-add-subjects" disabled={propertiesSelected.length == 0} className="btn btn-sm border-1 bg-gray-10 text-black font-medium rounded px-5" onClick={() => handleAddProperty('subj')}>+ Add subject</button> */}
                            </div>
                            <div>

                                {buttonClicked == 'comp' ?
                                    <button data-testid='test-button-comps'
                                        className="btn btn-sm btn-primary c-disabled">
                                        <span className="loader h-5 w-5 mx-2" ></span>
                                        <span className="px-2">+ Add Comp</span>
                                    </button>
                                    :
                                    <button data-testid='test-add-comps'
                                        onClick={() => { handleAddProperty('comp') }}
                                        className={`btn btn-sm btn-primary rouded ${propertiesSelected.length === 0 ? 'c-disabled' : ''}`}>
                                        + Add Comp
                                    </button>
                                }
                                {/* <button data-testid="test-add-comps" disabled={propertiesSelected.length == 0} className="btn btn-sm border-1 bg-gray-80 text-white font-medium rounded px-5" onClick={() => handleAddProperty('comp')}>+ Add Comp</button> */}
                            </div>
                        </div>
                    </div>
                </div>
            </Popover>
        </>
    )
}

export default AddPropertyToList